/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import InputField from "../../../shared-ui/input-field";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import _, { isArray } from "lodash";
import Button from "../../../shared-ui/button";
import ToggleButton from "../../../shared-ui/toggle-button";
import { metaData } from "./meta-data";
import { handleMetaRecoResultAPI } from "../../../../services/adminToolServices/getMetaRecommendation";
import { formattedText } from "../../../../utils/formattedText";
import Loader from "../../../shared-ui/loader";

interface RulesSectionProps {
  handleViewRules: (isRulesVisiable: boolean) => void;
  metaResponseProps: any;
  isEditMode?: boolean;
  isRunLoad?: boolean;
}

interface RulesSectionState {
  isAggregated: boolean;
  metaData: any;
  seperatedData: any;
  filteredSeperatedData: any;
  filteredAggregatedData: any;
  aggregatedData: any;
  metaResponseState: any;
  valueToSearch: any;
  isMenuOpen: boolean;
  accordionItemsState: string;
  isSearch: boolean;
}

class RulesSection extends React.Component<
  RulesSectionProps,
  RulesSectionState
> {
  node: any;
  constructor(props: any) {
    super(props);
    this.state = {
      isAggregated: false,
      metaData: [],
      seperatedData: [],
      aggregatedData: [],
      metaResponseState: {},
      valueToSearch: "",
      filteredSeperatedData: [],
      filteredAggregatedData: [],
      isMenuOpen: false,
      accordionItemsState: "collapsed",
      isSearch: false,
    };
  }

  componentDidMount = () => {
    let metaData: any = JSON.parse(localStorage.getItem("meta_result") || "{}");
    if (_.isNull(metaData)) {
      this.setState({
        metaData: [],
        seperatedData: [],
        aggregatedData: [],
      });
    }
    if (!_.isNull(metaData) && Object.keys(metaData).length > 0) {
      this.setState(
        {
          metaData:
            metaData?.data?.getMetaRecommendation?.metadata ||
            metaData?.data?.getMetaRecommendationById?.metadata,
          seperatedData:
            metaData?.data?.getMetaRecommendation?.metadata?.rules_fired ||
            metaData?.data?.getMetaRecommendationById?.metadata?.rules_fired,
          aggregatedData:
            metaData?.data?.getMetaRecommendation?.metadata
              ?.aggregated_user_attributes ||
            metaData?.data?.getMetaRecommendationById?.metadata
              ?.aggregated_user_attributes,
        },
        () => {
          let Arr: any = [];
          let data = this.state.seperatedData;
          this.state?.seperatedData?.map((ele: any, index: number) => {
            let isArrayOfObjects: boolean =
              _.isNull(ele?.action?.BoostHabitSku) &&
              _.isNull(ele?.action?.BoostSku) &&
              _.isNull(ele?.action?.Needstate) &&
              _.isNull(ele?.action?.Persona) &&
              _.isNull(ele?.action?.UserAttr) &&
              _.isNull(ele?.action?.UserReason);
            isArrayOfObjects && Arr.push(index);
          });
          _.pullAt(data, Arr);
          this.setState({
            seperatedData: data,
          });
        }
      );
    }
  };
  componentDidUpdate = () => {
    if (this.state.isMenuOpen) {
      const concernedElement: Element | any =
        document.querySelector(".section-options-wrapper");
      document.addEventListener("click", (event) => {
        if (!concernedElement?.contains(event.target)) {
          this.setState({
            isMenuOpen: false
          });
        }
      });
    }
    else {
      document.removeEventListener("click", this.handleOutsideClick, true);
    }

    const { metaResponseState } = this.state;
    const { metaResponseProps } = this.props;
    if (metaResponseState !== metaResponseProps) {
      let metaData: any = metaResponseProps;
      if (_.isNull(metaData)) {
        this.setState({
          metaData: [],
          seperatedData: [],
          aggregatedData: [],
          metaResponseState: metaResponseProps,
        });
      }
      if (!_.isNull(metaData) && Object.keys(metaData).length > 0) {
        this.setState(
          {
            metaData:
              metaData?.data?.getMetaRecommendation?.metadata ||
              metaData?.data?.getMetaRecommendationById?.metadata,
            seperatedData:
              metaData?.data?.getMetaRecommendation?.metadata?.rules_fired ||
              metaData?.data?.getMetaRecommendationById?.metadata?.rules_fired,
            aggregatedData:
              metaData?.data?.getMetaRecommendation?.metadata
                ?.aggregated_user_attributes ||
              metaData?.data?.getMetaRecommendationById?.metadata
                ?.aggregated_user_attributes,
            metaResponseState: metaResponseProps,
            isAggregated: false
          },
          () => {
            let Arr: any = [];
            let data = this.state.seperatedData;
            this.state.seperatedData &&
              this.state.seperatedData.length > 0 &&
              this.state.seperatedData.map((ele: any, index: number) => {
                let isArrayOfObjects: boolean =
                  _.isNull(ele?.action?.BoostHabitSku) &&
                  _.isNull(ele?.action?.BoostSku) &&
                  _.isNull(ele?.action?.Needstate) &&
                  _.isNull(ele?.action?.Persona) &&
                  _.isNull(ele?.action?.UserAttr) &&
                  _.isNull(ele?.action?.UserReason);
                isArrayOfObjects && Arr.push(index);
              });
            _.pullAt(data, Arr);
            this.setState({
              seperatedData: data,
            });
          }
        );
      }
    }
  };

  handleOutsideClick = (e: any) => {
    // ignore clicks on the component itself
    if (this.node) {
      if (this.node.contains(e.target)) {
        return;
      }
      this.handleClose();
    }
  };

  handleOnClickInputMenu = (e?: any) => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen,
    });
    e?.stopPropagation()
  };

  handleToggleButton = (e: any) => {
    this.setState(
      {
        isAggregated: !this.state.isAggregated,
        accordionItemsState: "expanded",
      },
      () => {
        this.handleAccordionState();
      }
    );
  };

  handleSearch = (valueToSearch: any) => {
    const { seperatedData, aggregatedData } = this.state;
    this.setState({
      valueToSearch: valueToSearch,
    });
    if (valueToSearch.length > 0) {
      this.setState({
        isSearch: true,
      });
    } else {
      this.setState({
        isSearch: false,
      });
    }
    if (valueToSearch?.trim()?.length > 1) {
      //seperated rules searching
      const seperatedFilteredData = seperatedData?.filter((item: any) => {
        const obj = item;
        let needstate = item?.action?.Needstate;
        let boostHabitSku = item?.action?.BoostHabitSku;
        let boostSku = item?.action?.BoostSku;
        let persona = item?.action?.Persona;
        let userAttr = item?.action?.UserAttr;
        let userReason = item?.action?.UserReason;

        if (
          item?.ID?.replaceAll("_", " ")
            ?.replaceAll("-", " ")
            ?.trim()
            .toLowerCase()
            ?.includes(
              valueToSearch?.replaceAll("_", " ")?.replaceAll("-", " ")?.trim()
            )
        ) {
          return obj;
        }
        if (!_.isNull(needstate)) {
          let filteredData = needstate?.filter(
            (item: any) =>
              item &&
              item?.ns
                ?.replaceAll("-", " ")
                ?.replaceAll("_", " ")
                ?.toLowerCase()
                ?.trim()
                .toLowerCase()
                ?.includes(
                  valueToSearch
                    ?.replaceAll("_", " ")
                    ?.replaceAll("-", " ")
                    ?.trim()
                )
          );
          if (filteredData.length > 0) {
            return obj;
          }
        }
        if (!_.isNull(boostHabitSku)) {
          let filteredData = boostHabitSku?.filter(
            (item: any) =>
              item &&
              item?.hbSkuId
                ?.toString()
                ?.toLowerCase()
                ?.replaceAll("-", " ")
                ?.replaceAll("_", " ")
                ?.toLowerCase()
                ?.trim()
                ?.includes(
                  valueToSearch
                    ?.replaceAll("_", " ")
                    ?.replaceAll("-", " ")
                    ?.trim()
                )
          );
          if (filteredData.length > 0) {
            return obj;
          }
        }
        if (!_.isNull(boostSku)) {
          let filteredData = boostSku?.filter(
            (item: any) =>
              item &&
              item?.skuId
                ?.replaceAll("-", " ")
                ?.replaceAll("_", " ")
                ?.toLowerCase()
                ?.trim()
                ?.includes(
                  valueToSearch
                    ?.replaceAll("_", " ")
                    ?.replaceAll("-", " ")
                    ?.trim()
                )
          );
          if (filteredData.length > 0) {
            return obj;
          }
        }
        if (!_.isNull(userAttr)) {
          let filteredData = userAttr?.filter(
            (item: any) =>
              item &&
              item?.ns
                ?.replaceAll("-", " ")
                ?.replaceAll("_", " ")
                ?.toLowerCase()
                ?.trim()
                ?.toLowerCase()
                ?.includes(
                  valueToSearch
                    ?.replaceAll("_", " ")
                    ?.replaceAll("-", " ")
                    ?.trim()
                )
          );
          if (filteredData.length > 0) {
            return obj;
          }
        }
        if (!_.isNull(persona)) {
          let filteredData = persona?.filter(
            (item: any) =>
              item &&
              item?.person
                ?.replaceAll("-", " ")
                ?.replaceAll("_", " ")
                ?.toLowerCase()
                ?.trim()
                ?.toLowerCase()
                ?.includes(
                  valueToSearch
                    ?.replaceAll("_", " ")
                    ?.replaceAll("-", " ")
                    ?.trim()
                )
          );
          if (filteredData.length > 0) {
            return obj;
          }
        }
        if (!_.isNull(userReason)) {
          let filteredData = userReason?.filter(
            (item: any) =>
              item?.attr
                ?.replaceAll("-", " ")
                ?.replaceAll("_", " ")
                ?.toLowerCase()
                ?.trim()
                .toLowerCase()
                ?.includes(
                  valueToSearch
                    ?.replaceAll("_", " ")
                    ?.replaceAll("-", " ")
                    ?.trim()
                ) ||
              item?.reason
                ?.replaceAll("-", " ")
                ?.replaceAll("_", " ")
                ?.toLowerCase()
                ?.trim()
                .toLowerCase()
                .includes(
                  valueToSearch
                    ?.replaceAll("_", " ")
                    ?.replaceAll("-", " ")
                    ?.trim()
                )
          );
          if (filteredData.length > 0) {
            return obj;
          }
        }
      });

      //aggregated rules searching
      const aggregatedFilteredData = aggregatedData?.filter((item: any) =>
        item?.attribute
          ?.replaceAll("_", " ")
          ?.replaceAll("-", " ")
          .toLowerCase()
          .includes(
            valueToSearch?.replaceAll("_", " ")?.replaceAll("-", " ")?.trim()
          )
      );
      this.setState({
        filteredSeperatedData: seperatedFilteredData,
        filteredAggregatedData: aggregatedFilteredData,
      });
    } else {
      this.setState({
        filteredSeperatedData: [],
        filteredAggregatedData: [],
      });
    }
  };

  handleCross = (e: any) => {
    if (this.state.isSearch) {
      this.setState({
        valueToSearch: "",
      });
    }
    this.setState({
      isSearch: false,
    });
  };

  handleClose = () => {
    this.setState({
      isMenuOpen: false,
    });
  };

  handleAccordionState = () => {
    const { accordionItemsState } = this.state;
    this.setState({
      isMenuOpen: false,
    });

    if (accordionItemsState === "collapsed") {
      const accordionButtonElement: Element | any = document.querySelectorAll(
        ".accordion_rules_button"
      );
      accordionButtonElement.forEach((element: any) => {
        element.setAttribute("aria-expanded", "true");
      });
      const accordionPanelElement: Element | any = document.querySelectorAll(
        ".accordion_rules_panel"
      );
      accordionPanelElement.forEach((element: any) => {
        element.removeAttribute("hidden");
      });
      this.setState({
        accordionItemsState: "expanded",
      });
    }
    if (accordionItemsState === "expanded") {
      const accordionButtonElement: Element | any = document.querySelectorAll(
        ".accordion_rules_button"
      );
      accordionButtonElement.forEach((element: any) => {
        element.setAttribute("aria-expanded", "false");
      });
      const accordionPanelElement: Element | any = document.querySelectorAll(
        ".accordion_rules_panel"
      );
      accordionPanelElement.forEach((element: any) => {
        element.setAttribute("hidden", "true");
      });
      this.setState({
        accordionItemsState: "collapsed",
      });
    }
  };
  render() {
    const {
      isAggregated,
      metaData,
      seperatedData,
      aggregatedData,
      filteredSeperatedData,
      valueToSearch,
      accordionItemsState,
      isMenuOpen,
      filteredAggregatedData,
      metaResponseState,
      isSearch,
    } = this.state;

    let seperatedDataToDisplay: any =
      valueToSearch?.trim()?.length <= 1
        ? seperatedData
        : filteredSeperatedData.length > 0
        ? filteredSeperatedData
        : [];
    let aggregatedDataToDisplay: any =
      valueToSearch?.trim()?.length <= 1
        ? aggregatedData
        : filteredAggregatedData.length > 0
        ? filteredAggregatedData
        : [];

    return (
      <div className={`rules-area section pull-left`}>
        {/* <div className="title">View Rules / Attributes here</div> */}
        <div className="inner-wrapper">
          {/* Section Header Start */}
          <div className="title-header">
            <div className="title">Rules</div>
            <div className="main-input">
              <div className="search-wrapper">
                <InputField
                  type={"text"}
                  placeHolder={"Search rules and attributes"}
                  className={"custom-input"}
                  handleInputChange={(e) => {
                    this.handleSearch(e.target.value.toLowerCase());
                  }}
                  inputValue={this.state.valueToSearch}
                />
                <div
                  className={isSearch ? "icon cross-icon" : "icon search-icon"}
                  onClick={(e) => this.handleCross(e)}
                ></div>
              </div>
              <div
                className="section-options-wrapper"
                onClick={(e: any) => { this.handleOnClickInputMenu(e) }}
              >
                <span
                  className="icon three-dot-icon"
                  // onClick={this.handleOnClickInputMenu}
                />
                <div
                  ref={(node) => {
                    this.node = node;
                  }}
                  className={isMenuOpen ? "options-view" : "hide"}
                >
                  <div
                    className="option"
                    onClick={() => this.props.handleViewRules(false)}
                  >
                    Hide Rules
                  </div>
                  {seperatedDataToDisplay?.length > 0 && isAggregated && (
                    <div className="option" onClick={this.handleAccordionState}>
                      {" "}
                      {accordionItemsState === "expanded" &&
                        "Collapse all Rules"}
                      {accordionItemsState === "collapsed" &&
                        "Expand all Rules"}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Section Header Ends */}
          {!_.isEmpty(metaResponseState?.data) ? (
            <>
              {/* Toggle Area Start */}
              <div className="toggle-area">
                <ToggleButton
                  {...this.props}
                  // handleOnClickToggle2={(selectedValue: any) => {
                  //   //this.handleClickToggle(one);

                  //   this.handleClickToggleFood(selectedValue);
                  // }}
                  // handleOnKyPressToggle2={(selectedValue: any, e: any) => {
                  //   if (e?.key === "Enter" || e?.key === " ") {
                  //     this.handleClickToggleFood(selectedValue);
                  //     //
                  //   }
                  // }}
                  isChecked={this.state.isAggregated}
                  handleOnClickToggle2={(state) => {
                    this.handleToggleButton(state);
                  }}
                  lableLeft={"Separated"}
                  lableRight={"Aggregated"}
                  type1="aggregated" // for right type
                  type2="separated" // for left type
                />
              </div>
              {/* Toggle Area Ends */}

              {/* Search Information Area Starts */}
              {valueToSearch?.trim()?.length > 1 && (
                <div className="rules-search-info">
                  {!isAggregated
                    ? filteredAggregatedData.length > 0
                      ? `Showing results for "${_.capitalize(valueToSearch)}"`
                      : `No results for "${_.capitalize(valueToSearch)}"`
                    : filteredSeperatedData.length > 0
                    ? `Showing results for "${_.capitalize(valueToSearch)}"`
                    : `No results for "${_.capitalize(valueToSearch)}"`}
                </div>
              )}
              {_.isEmpty(seperatedDataToDisplay) && isAggregated && valueToSearch==="" && (
                <div className="rules-search-info">
                  No rules triggered
                </div>
              )}
              {/* Search Information Area Ends */}

              <div className="rules-inner-wrapper">
                {/* Aggregated area Start */}
                <div
                  className={
                    !isAggregated ? "aggregated-area " : "aggregated-area hide"
                  }
                >
                  {aggregatedDataToDisplay?.length > 0 &&
                    aggregatedDataToDisplay.map(
                      (element: any, index: number) => (
                        <div className="aggregated-list">
                          <div className="attribute">{element?.attribute}</div>
                          <div className="score">{element?.score}</div>
                        </div>
                      )
                    )}
                </div>
                {/* Aggregated area Ends */}

                {/* Separated Area Start */}
                <div
                  className={
                    isAggregated
                      ? "custom-accordion "
                      : "custom-accordion hide "
                  }
                >
                  {/* Accordion Area For Separated Start */}

                  {seperatedData?.length > 0 && (
                    <Accordion allowZeroExpanded={true}>
                      {isArray(seperatedDataToDisplay) &&
                        seperatedDataToDisplay?.length > 0 &&
                        seperatedDataToDisplay.map(
                          (element: any, index: number) => (
                            <AccordionItem>
                              <AccordionItemButton className="accordion_rules_button">
                                <div className="item-btn-wrapper">
                                  <div className="question-title">
                                    {formattedText(
                                      element?.ID.replaceAll("_", " ")
                                    )}
                                  </div>
                                  <div className={"handleArrow"}></div>
                                </div>
                              </AccordionItemButton>
                              <AccordionItemPanel className="accordion_rules_panel">
                                {/* Aggregated area Start */}
                                {!_.isNull(element?.action) &&
                                  Object.keys(element?.action)?.map(
                                    (item: any, index: number) => (
                                      <div
                                        className={
                                          !_.isNull(
                                            element?.action?.[`${item}`]
                                          )
                                            ? "aggregated-area"
                                            : "aggregated-area hide"
                                        }
                                      >
                                        {item !== "__typename" && (
                                          <div className="action-name">
                                            {item}
                                          </div>
                                        )}
                                        {item !== "__typename" &&
                                          (item !== "UserReason"
                                            ? !_.isNull(
                                                element?.action?.[`${item}`]
                                              ) &&
                                              element?.action?.[`${item}`].map(
                                                (
                                                  element: any,
                                                  index: number
                                                ) => (
                                                  <div className="aggregated-list">
                                                    <div className="attribute">
                                                      {element?.ns ||
                                                        element?.skuId ||
                                                        element?.person ||
                                                        element?.hbSkuId}
                                                    </div>
                                                    <div className="score">
                                                      {element?.score}
                                                    </div>
                                                  </div>
                                                )
                                              )
                                            : !_.isNull(
                                                element?.action?.[`${item}`]
                                              ) &&
                                              element?.action?.[`${item}`].map(
                                                (element: any, index: number) =>
                                                  Object.keys(element).map(
                                                    (obj: any) =>
                                                      obj !== "__typename" && (
                                                        <div className="aggregated-list">
                                                          <div className="attribute">
                                                            {obj}
                                                          </div>
                                                          <div className="score">
                                                            {element[`${obj}`]}
                                                          </div>
                                                        </div>
                                                      )
                                                  )
                                              ))}
                                      </div>
                                    )
                                  )}

                                {/* Aggregated area Ends */}
                              </AccordionItemPanel>
                            </AccordionItem>
                          )
                        )}
                    </Accordion>
                  )}
                  {/* Accordion Area For Separated Ends */}
                </div>
                {/* Separated Area Ends */}
              </div>
            </>
          ) : this.props.isRunLoad ? (
            <Loader loaderClassName={"loader-wrapper align-middle"} />
          ) : (
            <div className="no-rules-wrapper">
              <div className="no-rules-msg">Hit 'Run' to get the rules</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default RulesSection;
